/**
 * senderGlyph — the avatar initial, as a leaf with NO imports (2026-09-19).
 *
 * The rule is three lines and it had two copies: `senderGlyph` in
 * senderIdentity.ts and `senderInitial` in GlobalChatSystem/groupSenderAttribution.ts.
 * Both of those modules import `ASSISTANT_SENDER_ID` from types/groupThreadMessageDoc,
 * which reaches repositories/firestoreUtils → `firebase/auth`, which touches
 * global `fetch` AT IMPORT TIME. So a module that wanted only the initial paid
 * for Firestore, and in the chat-isolation suites that is not a cost but a
 * failure: the suite dies with `ReferenceError: fetch is not defined` before a
 * single test body runs.
 *
 * Hence this file: zero imports, so anything may take the rule without taking
 * the graph. Both former homes re-export from here, which also retires the
 * duplicate — two copies of one rule is how the two start disagreeing about
 * what letter a person is.
 */

/** First visible character, uppercased; '?' when nothing usable. */
export function senderGlyph(label: string): string {
  const trimmed = (label ?? '').trim();
  if (!trimmed) return '?';
  return Array.from(trimmed)[0].toUpperCase();
}
